import { useState } from 'react'
import { LayoutDashboard } from 'lucide-react'
import { useGetMyWidgetsQuery } from '@/redux/service/widgets'
import { WidgetGrid } from '@/components/widgets/WidgetGrid'

export default function Widgets() {
  const { data, isLoading } = useGetMyWidgetsQuery()
  const groups = data?.data ?? []
  const [activeGroupId, setActiveGroupId] = useState<number | null>(null)
  const currentGroupId = activeGroupId ?? groups[0]?.group_id
  const activeGroup = groups.find(group => group.group_id === currentGroupId)

  if (isLoading) {
    return (
      <div className='flex items-center justify-center h-full text-sm text-muted-foreground'>
        Loading your widgets...
      </div>
    )
  }

  if (groups.length === 0) {
    return (
      <div className='flex flex-col items-center justify-center h-full text-center gap-2'>
        <LayoutDashboard className='h-8 w-8 text-muted-foreground' />
        <p className='text-sm font-medium text-foreground'>
          No widgets available yet
        </p>
        <p className='text-xs text-muted-foreground max-w-sm'>
          Ask your Super Admin to enable widgets for your role or account.
        </p>
      </div>
    )
  }

  return (
    <div className='flex flex-col h-full overflow-hidden'>
      <div className='shrink-0 flex flex-wrap p-1 bg-muted border border-border rounded-xl gap-1 w-fit mb-4'>
        {groups.map(group => (
          <button
            key={group.group_id}
            onClick={() => setActiveGroupId(group.group_id)}
            className={`px-4 h-9 text-xs font-medium transition-all duration-200 rounded-lg flex items-center justify-center ${
              group.group_id === currentGroupId
                ? 'bg-primary text-primary-foreground shadow-sm'
                : 'text-muted-foreground hover:text-foreground hover:bg-white/5'
            }`}
          >
            {group.group_name}
          </button>
        ))}
      </div>

      <div className='flex-1 overflow-auto pb-6'>
        {activeGroup && (
          <WidgetGrid
            key={activeGroup.group_id}
            groupId={activeGroup.group_id}
            widgets={activeGroup.widgets}
          />
        )}
      </div>
    </div>
  )
}
